<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">

        <b-button block v-b-toggle.term-section-9
          class="text-left fw-500 d-flex align-items-center justify-content-between">
              <div>
                  <span class="box-numbering">09</span>
                  <span>Privacy</span>    
              </div>
              <span 
                  class="toggle-icon" 
                  :class="{ active: isOpen }"
              >
                  <span class="plus">+</span>
                  <span class="cross">×</span>
              </span> 
        </b-button>

      </b-card-header>
      <b-collapse
        id="term-section-9"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            Privacy Your personal information is protected in accordance with
            our Privacy Policy, which you can review here. By using {{ companyName }}
            services, you consent to our collection, use, and sharing of your
            information as described in the Privacy Policy.
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "term-5",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
